import { AbstractFault, Fault } from "@app/shared";
 
@Fault('Modutecture.Shared.DTOsV2.RoomNotFoundFault, Modutecture.Shared')
export class RoomNotFoundFault extends AbstractFault {
    public roomId: string;
}
 
@Fault('Modutecture.Shared.DTOsV2.DepartmentNotFoundFault, Modutecture.Shared')
export class DepartmentNotFoundFault extends AbstractFault {
    public departmentId: string;
}
 
@Fault('Modutecture.Shared.DTOsV2.CategoryNotFoundFault, Modutecture.Shared')
export class CategoryNotFoundFault extends AbstractFault {
    public categoryId: string;
}
 
@Fault('Modutecture.Shared.DTOsV2.ProgramNotFoundFault, Modutecture.Shared')
export class ProgramNotFoundFault extends AbstractFault {
    public programId: string;
}
 
@Fault('Modutecture.Shared.DTOsV2.ProjectNotFoundFault, Modutecture.Shared')
export class ProjectNotFoundFault extends AbstractFault {
    public projectId: string;
}